import { separators } from '../../constants';
import { is } from '../../utils';

export function toFixedComma(
  number: string | number = null,
  fractionDigits = 2,
): string {
  const val = Number(number);

  if (number === null) {
    return separators.emptyNumber;
  }

  return val.toFixed(fractionDigits).replace(/\.?0+$/g, ''); // removes zero signs at the end
}

export function numberFormat(
  number?: string | number | null,
  separator = separators.space,
  fractionDigits?: number,
): string {
  if (is.nullOrUndefined(number) || isNaN(number as number)) {
    return '-';
  }

  return toFixedComma(number, fractionDigits)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${separator}`)
    .replace(/(\..+)\s+/g, '$1')
    .toString();
}

export function numbersWithFloatPointFormat(
  number?: string | number | null,
  separator = separators.space,
): string {
  // if - 1.0345 -> 0
  // if - 10.00345 -> 00
  // if - 0.000123 -> 000
  const zeroCount = number
    ? String(number)
        .replace(/.+\./, '')
        .replace(/[1-9].*/, '')
    : '';

  return numberFormat(
    number,
    separator,
    zeroCount.length < 2 ? 2 : zeroCount.length + 1,
  );
}

export function chartNumberFormat(number: string | number): string {
  return numberFormat(number);
}

export function chartNumberPrettyFormat(
  number: string | number,
  // index?: number,
): string {
  // billion
  if (/^\d{1,3}\d{9}$/g.test(String(number))) {
    return numberFormat(Number(number) / 1000000000) + ' B';
  }

  // million
  if (/^\d{1,3}\d{6}$/g.test(String(number))) {
    return numberFormat(Number(number) / 1000000) + ' M';
  }

  // thousand
  if (/^\d{1,3}\d{3}$/g.test(String(number))) {
    return numberFormat(Number(number) / 1000) + ' K';
  }

  return numberFormat(number);
}

export function toPriceFormat(
  number: number | string = null,
  fractionDigits = 2,
): string {
  const val = Number(number);

  if (number === null) {
    return separators.emptyNumber;
  }

  return numberFormat(val.toFixed(fractionDigits));
}

export function toPercent(number: number | string = null): string {
  if (is.nullOrUndefined(number) || isNaN(number as number)) {
    return '-';
  }

  return toFixedComma(number, 1) + '%';
}

// Different count of decimal signs
// 1.236 -> 1.24%    |    0.12 -> 0.12%    |    12.68 -> 12.7%
export function toProgressivePercent(number: number | string = null): string {
  if (is.nullOrUndefined(number) || isNaN(number as number)) {
    return '-';
  }

  const int = parseInt(number as string);

  if (!isNaN(int)) {
    if (int >= 10) {
      return toFixedComma(number, 1) + '%';
    }

    return toFixedComma(number, 2) + '%';
  }

  return toPercent(number);
}

export function toIntegerFormat(number: number | string = null): string {
  return toFixedComma(number, 0);
}
